export const PAGE_FIX_SELECTOR_QUERIES = {
    query_selector: 'q',
    tree_walker: 't',
} as const;
